export default [
  {
    path: '/file-view/attachment/:id',
    name: 'file-view-attachment',
    component: () => import('@/views/empty/file-view/AttachmentView.vue'),
    meta: { layout: 'empty', takeToken: true },
  },
  {
    path: '/file-down/start',
    name: 'file-down-start',
    component: () =>
      import('@/views/empty/file-view/WechatFileErrorDownload.vue'),
    meta: { layout: 'empty', takeToken: true },
  },
];
